import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { lazyWithRetry } from './utils/lazyWithRetry';
import fetcher from "./fetcher/fetch";
import { WeezSocket } from "@weezevent/piglet";
import Loader from "./loader";
import ErrorBoundary from './components/errorBoundary';
import NeoConnect from "./components/connect/neoConnect";

import { library } from '@fortawesome/fontawesome-svg-core';
import { ticketIcons } from '@weezevent/ts2-tickets/icons';
import { componentIcons } from '@weezevent/ts2-components/icons';

// Add icons used by ts2-tickets and ts2-components packages
library.add(...ticketIcons, ...componentIcons);

// Lazy-loaded route components
const Widget = lazyWithRetry(() => import('./widget/widget'));
const Components = lazyWithRetry(() => import('./components/jo-components'));
const LanguageManager = lazyWithRetry(() => import('./components/language-manager'));

fetcher.initialize(window.weezConfig.url.api);

function getRootSize() {
    // Get root div
    let rootTag = document.getElementById('root');
    let rootTagSettings = rootTag.getBoundingClientRect();
    return Math.ceil(rootTagSettings.height);
}

function resizeEvent() {
    let height = getRootSize();
    WeezSocket.send({ type: "resize", origin: "neo", payload: { height } });
}

setInterval(resizeEvent, 200);

function App() {
    return (
        <Suspense fallback={
            <Loader/>
        }>
            <ErrorBoundary>
                <NeoConnect>
                    <Router basename={'ticket'}>
                        <Switch>
                            <Route exact path="/preview" render={() => <Widget />} />
                            <Route exact path="/demo-components" render={() => <Components />} />
                            <Route exact path="/:widgetKey" render={({ match }) => <LanguageManager widgetKey={match.params.widgetKey} />} />
                        </Switch>
                    </Router>
                </NeoConnect>
            </ErrorBoundary>
        </Suspense>
    );
}

export default App;
